'use client';

import { AppealStat } from '@/lib/types';
import { createRandomId } from '@/lib/utils';
import { Empty } from '@/ui';
import { Skeleton, Table } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { StatisticsList } from './StatisticsList';

type Data = {
  breadcrumb: string;
  menu_id: number;
  menu_title: string;
  menu_item_id: number;
  data: AppealStat;
};

type Props = { statistics: Data; isLoading: boolean };

const HEADING_TITLES = ['murojaat-manbasi', 'barchasi', 'jarayondagi-murojaatlar', 'yopilgan-murojaatlar'];

export function StatisticsContent({ statistics, isLoading = false }: Props) {
  const t = useTranslations();
  return (
    <>
      <StatisticsList>
        {isLoading ? (
          <StatisticsLoading count={5} />
        ) : statistics?.data && statistics?.data?.all_data && statistics?.data?.all_data?.length > 0 ? (
          <Table.ScrollContainer minWidth={500} w="100%" pt="lg" type="native">
            <Table
              highlightOnHover
              withColumnBorders
              bg="#eef4fe"
              borderColor="#bed2eb"
              horizontalSpacing="sm"
              verticalSpacing="md"
              style={{ borderRadius: '5px' }}
            >
              <Table.Thead>
                <Table.Tr>
                  <Table.Th className="!text-center">№</Table.Th>
                  {HEADING_TITLES.map((title) => (
                    <Table.Th className="!text-center" key={title}>
                      {t(title)}
                    </Table.Th>
                  ))}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {statistics?.data?.all_data?.map((item, ind) => (
                  <Table.Tr key={ind}>
                    <Table.Td align="center">{ind + 1}</Table.Td>
                    <Table.Td align="center">{t(item?.source_title)}</Table.Td>
                    <Table.Td align="center">{item?.all}</Table.Td>
                    <Table.Td align="center">{item?.process}</Table.Td>
                    <Table.Td align="center">{item?.closed}</Table.Td>
                  </Table.Tr>
                ))}
                <Table.Tr>
                  <Table.Td colSpan={2} align="center">
                    {t('barchasi')}
                  </Table.Td>
                  <Table.Td align="center">{statistics?.data?.total?.all}</Table.Td>
                  <Table.Td align="center">{statistics?.data?.total?.process}</Table.Td>
                  <Table.Td align="center">{statistics?.data?.total?.closed}</Table.Td>
                </Table.Tr>
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>
        ) : (
          <Empty />
        )}
      </StatisticsList>
      <div style={{ display: 'inline' }}>
        <span style={{ color: 'red' }}>* </span>
        <span
          dangerouslySetInnerHTML={{
            __html: t(
              'ma-lumotlar-o-zbekiston-respublikasi-prezidentining-virtual-qabulxonasi-pm-gov-uz-bilan-to-g-ridan-to-g-ri-integratsiya-orqali-taqdim-etilgan'
            ),
          }}
        />
      </div>
    </>
  );
}

function StatisticsLoading({ count = 2 }: { count?: number }) {
  return (
    <Table
      bg="#eef4fe"
      borderColor="#bed2eb"
      horizontalSpacing="sm"
      verticalSpacing="md"
      style={{ borderRadius: '5px' }}
    >
      <Table.Thead>
        <Table.Tr>
          {Array.from({ length: 4 }).map(() => (
            <Table.Th key={createRandomId()}>
              <Skeleton component="span" display="block" width="100%" height="1.5rem" />
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {Array.from({ length: count }).map(() => (
          <Table.Tr key={createRandomId()}>
            {Array.from({ length: 4 }).map(() => (
              <Table.Th key={createRandomId()}>
                <Skeleton component="span" display="block" width="100%" height="1.5rem" />
              </Table.Th>
            ))}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
